import { sendAnalyticsEvent } from './analytics'

type Submission = {
    form?: HTMLFormElement
    response?: { success?: boolean; data?: { insert_id?: number | string; result?: { redirectUrl?: string; message?: string; action?: string }; nextAction?: unknown } }
}

export function deferRedirect(
    result: NonNullable<NonNullable<Submission['response']>['data']>['result'],
    navigate: (url: string) => void,
) {
    if (!result?.redirectUrl) return
    const destination = result.redirectUrl
    delete result.redirectUrl
    result.action = 'hide_form'
    result.message ||= 'Thank you. Your enquiry has been received.'
    const startedAt = Date.now()
    let redirected = false
    const complete = () => {
        if (redirected) return
        redirected = true
        clearTimeout(fallback)
        setTimeout(() => navigate(destination), Math.max(0, 5500 - (Date.now() - startedAt)))
    }
    const fallback = setTimeout(complete, 6500)
    return complete
}

export function createSubmissionTracker(
    push: (event: Record<string, unknown>) => void,
    navigate?: (url: string) => void,
) {
    const seen = new Set<string>()

    return ({ form, response }: Submission) => {
        if (!form || response?.success !== true || !response.data?.result || response.data.nextAction) return

        const formId = form.getAttribute('data-form_id')
        const event = form.getAttribute('data-analytics-event')
        if (!event || !/^[a-z][a-z0-9_]{0,29}_submitted$/.test(event)) return
        const entryId = String(response.data.insert_id ?? '')
        if (!formId || !/^\d+$/.test(formId) || !/^[1-9]\d*$/.test(entryId)) return

        const submissionId = `ff-${formId}-${entryId}`
        if (seen.has(submissionId)) return
        seen.add(submissionId)

        const complete = navigate ? deferRedirect(response.data.result, navigate) : undefined

        push({
            ...(complete ? { event_callback: complete, event_timeout: 6000 } : {}),
            event,
            form_id: formId,
        })
    }
}

export function initFormConversions() {
    const track = createSubmissionTracker(({ event, ...parameters }) => {
        sendAnalyticsEvent(event as string, parameters)
    }, url => window.location.assign(url))

    document.addEventListener('fluentform_submission_success', event => {
        if (event instanceof CustomEvent && event.detail?.form instanceof HTMLFormElement) {
            track(event.detail)
        }
    })
}
